// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2v6bA","title":"ClientInsurance_title__362tG","itemText":"ClientInsurance_itemText__kBHwX"};